import { authService } from './auth.service'

// Definition of the profiles and their permissions
const PERMISSIONS = {
  ADMIN: ['read', 'write', 'delete', 'manage_users', 'manage_settings'],
  MANAGER: ['read', 'write', 'delete'],
  USER: ['read']
}

export const authorizationService = {
  /**
   * Checks whether the current user has the specified permission
   * @param {string} permission - The permission to be checked
   * @returns {boolean} - True if the user has the permission, false otherwise
   */
  hasPermission(permission) {
    const currentUser = authService.getCurrentUser()
    if (!currentUser) return false
    
    const profile = currentUser.profile || 'USER'
    const userPermissions = PERMISSIONS[profile] || []
    
    return userPermissions.includes(permission)
  },
  
  /**
   * Checks whether the current user has the specified profile
   * @param {string|string[]} profiles - The profile or array of profiles to be checked
   * @returns {boolean} - True if the user has one of the profiles, false otherwise
   */
  hasProfile(profiles) {
    const currentUser = authService.getCurrentUser()
    if (!currentUser) return false
    
    const userProfile = currentUser.profile || 'USER'
    
    if (Array.isArray(profiles)) {
      return profiles.includes(userProfile)
    }
    
    return userProfile === profiles
  },
  
  /**
   * Gets the profile of the current user
   * @returns {string} - The current user's profile or 'USER' as default
   */
  getUserProfile() {
    const currentUser = authService.getCurrentUser()
    if (!currentUser) return 'USER'
    
    return currentUser.profile || 'USER'
  }
}
